/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProgramResponseDto } from '../../models/program-response-dto';

export interface GetCustomerProgram$Params {
  bpGuid: string;
  programName?: string;
}

export function getCustomerProgram(http: HttpClient, rootUrl: string, params: GetCustomerProgram$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ProgramResponseDto>>> {
  const rb = new RequestBuilder(rootUrl, getCustomerProgram.PATH, 'get');
  if (params) {
    rb.query('bpGuid', params.bpGuid, {});
    rb.query('programName', params.programName, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ProgramResponseDto>>;
    })
  );
}

getCustomerProgram.PATH = '/ebs-programs/customer';
